import React from "react";

const RightSideDoor = () => {
    return (
        <svg width="82" height="93" viewBox="0 0 82 93" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M76.1291 92.2246H81.7188L81.7187 0.374611H76.1291L76.1291 92.2246Z" fill="#4A5353" />
            <path d="M0.296875 92.3008C0.296875 41.4919 36.5629 0.300781 81.2969 0.300781" stroke="#4A5353" stroke-width="0.6" stroke-miterlimit="10" />
        </svg>
    )
}
export default RightSideDoor;